<template>
  <div class="eleQueryTemp3">
    <div class="searchBox">
      <el-date-picker v-model="dateTime" class="monthPicker" end-placeholder="结束时间"
                      popper-class="date-style"
                      range-separator="→" start-placeholder="开始时间"
                      style="width: auto"
                      type="datetimerange"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      @change="searchFun">
      </el-date-picker>
      <el-select v-model="dataVal" clearable filterable
                 style="width: 220px;display: inline-block;margin-left: 20px" @change="searchFun">
        <el-option v-for="(item,index) in dataSelectList" :key="index" :label="item.name"
                   :value="item.id+'_'+item.name"/>
      </el-select>
      <el-button type="primary" @click="exportClick">导出</el-button>
    </div>

    <div class="content">
      <!--表格-->
      <el-table v-loading="loading" :data="tableData" style="width: 100%;margin-top: 20px">
        <template #empty>
          <el-empty class="emptyClass" description="暂无数据信息"
                    image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
          </el-empty>
        </template>
        <el-table-column label="设备名称" prop="name"></el-table-column>
        <el-table-column label="开始时间" prop="startTime"></el-table-column>
        <el-table-column label="开始值" prop="startValue"></el-table-column>
        <el-table-column label="结束时间" prop="endTime"></el-table-column>
        <el-table-column label="结束值" prop="endValue"></el-table-column>
        <el-table-column v-show="dataVal" :label="dataVal.split('_')[1]" prop="difference"></el-table-column>
      </el-table>
      <div class="pag">
        <el-pagination v-model:page-size="pageSize" :current-page="pageNumber" :page-sizes="[10, 20, 50, 100]"
                       :total="total" background
                       layout="total,sizes,prev, pager, next" @size-change="handleSizeChange"
                       @current-change="pageChange"/>
      </div>
    </div>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {defineProps, onMounted, ref, watch} from "vue";
import {getReadingStatisticsTableApi} from "@/api/modules/eleChargeQuery";
import qs from "qs";
import {ElLoading, ElMessage} from "element-plus";
import {http} from "@/api";
import {getIndexSelectAPi} from "@/api/modules/alarm";
import moment from "moment";

const props = defineProps(['custerObj'])
let dateTime = ref([moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")])
let dataVal = ref('')
// 获取字典选项
let dataSelectList = ref([])
const getIndexSelectFun = function () {
  getIndexSelectAPi().then(res => {
    if (res.data.code === 0) {
      dataSelectList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 获取表格数据****************************************************************************************
let tableData = ref([])
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref(7)
let loading = ref(false)
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getTableDataFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getTableDataFun()
}
const getTableDataFun = function () {
  loading.value = true
  getReadingStatisticsTableApi(qs.stringify({
    pageNumber: pageNumber.value,
    pageSize: pageSize.value,
    startTime: dateTime.value[0] ? dateTime.value[0] : '',
    endTime: dateTime.value[1] ? dateTime.value[1] : '',
    dictId: dataVal.value.split('_')[0],
    projectId: custerObj.value.id
  })).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = res.data.result.list
      total.value = Number(res.data.result.total)
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


const searchFun = function (e) {
  pageNumber.value = 1
  getTableDataFun()
}

/*加载loading*/
const loadingAdd = ref()
const openFullScreen = () => {
  loadingAdd.value = ElLoading.service({
    lock: true,
    text: '',
    background: 'rgba(0, 0, 0, 0.7)',
  })
}
// 确认导出
const exportClick = function () {
  if (dateTime.value && dateTime.value.length > 1 && dataVal.value) {
    openFullScreen()
    window.location.href = http + 'zouk/rest/export/exportReadingStatistics?startTime=' + (dateTime.value[0] ? dateTime.value[0] : '') + '&endTime=' + (dateTime.value[0] ? dateTime.value[1] : '') + '&projectId=' + custerObj.value.id + '&dictId=' + dataVal.value.split('_')[0]
    setTimeout(() => {
      loadingAdd.value.close();
      dialogVisible2.value = false
      ElMessage({
        type: 'success',
        message: '导出成功'
      });
    }, 1000);
    loadingAdd.value.close()
  } else {
    ElMessage({
      type: 'info',
      message: '请选择导出条件'
    });
  }
}


let custerObj = ref()
watch(() => props.custerObj, (newVal) => {
  custerObj.value = newVal
  getTableDataFun()
}, {deep: true, immediate: true})


onMounted(() => {
  getIndexSelectFun()
  getTableDataFun()
})

</script>

<style lang="less" scoped>
.eleQueryTemp3 {
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.09);

  .searchBox {
    //display: flex;
    //justify-content: space-between;
    .el-button {
      float: right;
    }
  }

  .content {
    width: 100%;
    height: calc(100% - 32px);
    background: #fff;
    overflow: auto;
    display: block;
    padding: 0;

    .el-table {
      color: rgba(3, 10, 26, 0.85);
      height: calc(100% - 84px);
      //border: 1px solid #ebeef5;
      //margin: 24px;

      .el-table__body-header, .el-table__header, .el-table__body {
        th {
          background-color: rgb(250, 250, 250);
          font-weight: 500;
        }

        //th:nth-child(2)::before, th:nth-child(3)::before, th:nth-child(4)::before, th:nth-child(5)::before, th:nth-child(6)::before, th:nth-child(7)::before {
        //  content: '';
        //  width: 1px;
        //  height: 1.6em;
        //  position: absolute;
        //  left: 0;
        //  top: 50%;
        //  transform: translateY(-50%);
        //  background-color: rgba(0, 0, 0, 0.06);
        //}
      }
    }

    //分页
    .pag {
      width: 100%;
      height: 32px;
      padding: 16px 0;

      .el-pagination {
        float: right;
      }
    }
  }
}
</style>
